import { useCallback } from 'react';
import { App, Modal } from 'antd';

import { useTranslation } from 'react-i18next';
import { useDeleteRegionalCalendarMutation } from 'entities/calendar';

const useDeleteRegionalCalendar = (calendarId: string, calendarName: string): (() => void) => {
  const { t } = useTranslation();
  const { mutateAsync: deleteRegionalCalendarMutate } = useDeleteRegionalCalendarMutation(calendarId);

  const { modal } = App.useApp();

  const openDeleteModal = useCallback((): void => {
    const instanse = modal.confirm({
      title: t('Calendar:deleteRegionalCalendarModal.title', { name: calendarName }),
      centered: true,
      closable: true,
      maskClosable: true,
      cancelText: t('Shared:noBtn.text'),
      width: 450,
      icon: null,
      okButtonProps: { loading: false },
      onOk: async () => {
        instanse.update({ okButtonProps: { loading: true } });

        try {
          await deleteRegionalCalendarMutate(calendarId);
          Modal.destroyAll();
        } catch (error) {
          instanse.destroy();
          modal.error({
            title: t('Calendar:deleteRegionalCalendarModal.errorModal.title'),
            centered: true,
            closable: true,
            maskClosable: true,
            okText: 'OK',
            width: 450,
            icon: null,
          });
        }
      },
    });
  }, [calendarId, calendarName, deleteRegionalCalendarMutate, modal, t]);

  return openDeleteModal;
};

export { useDeleteRegionalCalendar };
